import { Link, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, Button, Layout, Spin, theme } from 'antd';

import { PageLayout } from '@app/web-components';

import { NotFoundPage } from '../../common';
import { useFindBundleById } from '../data';
import { EditForm } from '../forms';

export const EditPage = () => {
  const { id } = useParams();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();

  const { data, isError, isPending } = useFindBundleById({ bundleId: Number(id) || 0 });

  if (isError || (!isPending && !data)) {
    return (
      <NotFoundPage subTitle="Sorry, this bundle does not exist or was deleted.">
        <Button type="primary" onClick={() => navigate('../')}>
          Back to Bundles
        </Button>
      </NotFoundPage>
    );
  }

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[{ title: <Link to="/">Home</Link> }, { title: <Link to="../">Bundles</Link> }, { title: 'Edit' }]}
      />
      <Layout.Content
        style={{
          padding: 24,
          margin: 'auto',
          height: '100%',
          width: '100%',
          maxWidth: 1200,
          minHeight: 0,
          background: colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Edit Bundle" />
        {isPending ? <Spin style={{ width: '100%' }} /> : <EditForm record={data} />}
      </Layout.Content>
    </>
  );
};
